module.exports = __webpack_public_path__ + "img/Scegli-i-posti-da-visitare.7cdf8a2c.png";